module.exports = require('./reserved-words');
